// ============================================
// ROLC OneROLC - API Endpoints
// Version: 3.6.0
// ============================================

import { apiCall } from './apiClient.js';

// ============================================
// Survey Endpoints
// ============================================
export async function getSurveys(token) {
    return apiCall('getSurveys', { token });
}

export async function getEvents(surveyName) {
    return apiCall('getEvents', { surveyName });
}

export async function submitSurvey(token, submissions, surveyName) {
    return apiCall('submit', { token, submissions, surveyName });
}

// ============================================
// Auth Endpoints
// ============================================
export async function searchMembers(query) {
    return apiCall('searchMembers', { query });
}

export async function checkPinStatus(fullName, lastName) {
    return apiCall('checkPinStatus', { fullName, lastName });
}

export async function forgotPin(fullName, lastName) {
    return apiCall('forgotPin', { fullName, lastName });
}

// ============================================
// Admin Endpoints
// ============================================
export async function checkAdmin(token) {
    return apiCall('checkAdmin', { token });
}

export async function adminSummary(adminToken, viewMode, surveyName, dateFrom, dateTo) {
    return apiCall('adminSummary', { adminToken, viewMode, surveyName, dateFrom, dateTo });
}

export async function adminChoiceDetail(adminToken, surveyName, eventName, choice, dateFrom, dateTo, viewMode) {
    return apiCall('adminChoiceDetail', { adminToken, surveyName, eventName, choice, dateFrom, dateTo, viewMode });
}

export async function getAdminSurveys(token) {
    return apiCall('getAdminSurveys', { token });
}

export async function getAdminEvents(token, surveyName) {
    return apiCall('getAdminEvents', { token, surveyName });
}

export async function saveSurvey(token, name, description, accessLevel, open, autoSchedule, startDate, startTime, endDate, endTime, repeat, customDays) {
    return apiCall('saveSurvey', { token, name, description, accessLevel, open, autoSchedule, startDate, startTime, endDate, endTime, repeat, customDays });
}

export async function deleteSurvey(token, name) {
    return apiCall('deleteSurvey', { token, name });
}

export async function saveEvent(token, surveyName, eventName, type, maxSelect, options, show, rowIndex, required, dateFormat = null) {
    return apiCall('saveEvent', { token, surveyName, eventName, type, maxSelect, options, show, rowIndex, required, dateFormat });
}

export async function deleteEvent(token, surveyName, rowIndex) {
    return apiCall('deleteEvent', { token, surveyName, rowIndex });
}

export async function bulkImportMembers(token, members) {
    return apiCall('bulkImportMembers', { token, members });
}

export async function resetPin(token, targetName) {
    return apiCall('resetPin', { token, targetName });
}

export async function masterLogin(masterPassword) {
    return apiCall('masterLogin', { masterPassword });
}

export async function auditLogView(masterToken) {
    return apiCall('auditLogView', { masterToken });
}

export async function auditLogToggleVisibility(masterToken, newVisibility) {
    return apiCall('auditLogToggleVisibility', { masterToken, newVisibility });
}

export async function surveyArchiveToggleVisibility(masterToken, newVisibility) {
    return apiCall('surveyArchiveToggleVisibility', { masterToken, newVisibility });
}

export async function getAuditLogVisibility() {
    return apiCall('getAuditLogVisibility', {});
}

export async function getSurveyArchiveVisibility() {
    return apiCall('getSurveyArchiveVisibility', {});
}

export async function syncNow(token) {
    return apiCall('syncNow', { token });
}

export async function getSheetUrl(token) {
    return apiCall('getSheetUrl', { token });
}


